// extracted by mini-css-extract-plugin
export var button = "_ak-4";
export var hasDarkBackground = "_ak-7";
export var hasLightBackground = "_ak-6";
export var iconWrapper = "_ak-0";
export var large = "_ak-2";
export var medium = "_ak-1";
export var small = "_ak-5";
export var xsmall = "_ak-3";